// Home.js
import React from "react";
import { Container } from "./styles";

const Home = () => {
  const name = localStorage.getItem("name");

  return (
    <Container>
      <h3>Home</h3>
      {name && <h5>Olá {name}, como vai?</h5>}
    </Container>
  );
};

export default Home;
